import { useDispatch, useSelector } from "react-redux";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import Tooltip from "@mui/material/Tooltip";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { Grid, Radio, Checkbox } from "@mui/material";
import InputData from "./InputData";
import InfoIcon from "@mui/icons-material/Info";
import CancelIcon from "@mui/icons-material/Close";
import UploadMasterData from "./UploadMasterData";
import { getRequest } from "../../Services/AxiosConfiguration";
import { API_BASE_URL, SELECTED_DISPLAY_FOLDER_API } from "../../Utils/Config";
import {
  displayFolderList,
  openErrorDialog,
  selectedFolderListError,
  selectedUploadFolderListSuccess,
} from "../../Redux/Actions/InputData";
import "./style.css";
import SelectDataUpload from "./SelectDataUpload";
import { useEffect, useState } from "react";
import CGOInputModal from "./CgoInputModal";

const BootstrapDialog = styled(Dialog)(({ theme }: any) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function UploadModal(props: any) {
  const dispatch: any = useDispatch();
  const [selectedScenario, setSelectedScenario] = useState<string>("");
  let useCaseName = localStorage.getItem("selectedUsecase");
  const [modalTitleText, setModalTitleText] = useState<any>(
    "Create/View Scenario"
  );

  const [inputFolderName, setInputFolderName] = useState("");
  const [inputFolderId, setInputFolderId] = useState("");
  const { isFolderSelected, folderSelectionMessage } = useSelector(
    (state: any) => state.InputDataReducers
  );

  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId
  );
  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId
  );

  const handleNextInputData = (selectedData: any) => {
    let folderSelected = selectedData;
    let folder_id = folderSelected?.id;
    setInputFolderName(folderSelected?.folder);
    setInputFolderId(folder_id);
    // Selected Folder API call
    dispatch(displayFolderList());
    const urls = API_BASE_URL + SELECTED_DISPLAY_FOLDER_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(urls, { folder_id: folder_id }, header)
      .then((response) => {
        // getRequest(urls + "?folder_id =" + folder_id,{}, header).then((response) => {
        if (response.status === 200) {
          dispatch(selectedUploadFolderListSuccess(response.data?.data));
          //dispatch(selectedFolderListSuccess(response.data?.data));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
        dispatch(selectedFolderListError(error));
      });
  };

  let uc = localStorage.getItem("selectedUsecase");
  let sr = localStorage.getItem("selectedRadio");
  const [headingStatus, setHeadingStatus] = useState<any>(false);

  useEffect(() => {
    if (
      (uc === "Short Term" || uc === "Medium Term") &&
      (sr === "masterData" || sr === "inputData")
    ) {
      setHeadingStatus(true);
    } else {
      setHeadingStatus(false);
    }
  }, [uc, sr]);

  // Radio button selection
  const handleRadioSelection = (e: any) => {
    const value = e.target.value;
    if (
      props.isSelectedScenarios === true &&
      (uc === "Short Term" || uc === "Medium Term")
    ) {
      // set localstorage
      const selectedScenario =
        value === "masterData" ? "createScenario" : "existingScenario";
      localStorage.setItem("selectedScenarioRadio", selectedScenario);
      setSelectedScenario(value);
    } else {
      props.handleChangeRadio(e);
    }
  };
  const scenarioRadioSelection = localStorage.getItem("selectedScenarioRadio");

  const handleUploadNowWrapper = (
    e: any,
    runType: "newrun" | "rerun" = "newrun"
  ) => {
    // prevent default if an event is passed
    if (e && typeof e.preventDefault === "function") e.preventDefault();

    if (typeof props.handleUploadNow === "function") {
      // forward to parent-provided handler
      return props.handleUploadNow(e, runType);
    }

    // fallback: warn (or you can dispatch directly here if UploadModal should perform upload)
  };

  // props.selectRadio for COG and long term
  // selctedScenario for short term and medium term
  console.log(props.selectRadio, "11111", selectedScenario, "selected radio");
  return (
    <>
      {/* {isFolderSelected && (
        <SelectDataUpload
          isOpen={isFolderSelected}
          inputFolderName={inputFolderName}
        />
      )} */}

      <div>
        <BootstrapDialog
          onClose={props.onClose}
          aria-labelledby="customized-dialog-title"
          open={props.isOpen}
          className={
            modalTitleText.length ? "COG-modal-popup" : "small-modal-popup"
          }
        >
          <div className="modal-header">
            <Grid container spacing={1}>
              <Grid item xs={10} md={10} lg={10}>
                <h3>
                  {props.isNext && props.selectRadio === "masterData"
                    ? "Upload Master data"
                    : props.isNext && props.selectRadio === "inputData"
                    ? "Upload Input data"
                    : props.isUploadScenarioData === true
                    ? "Upload Scenario data"
                    : props.isSelectedScenarios === true
                    ? modalTitleText
                    : useCaseName}
                </h3>
                <p className="sub-title-text">
                  {props.isNext && props.selectRadio === "masterData"
                    ? "Upload the below required files."
                    : props.isNext && props.selectRadio === "masterData"
                    ? "Upload Input data"
                    : props.isUploadScenarioData === true
                    ? "Upload the below required files."
                    : ""}
                </p>
              </Grid>
              <Grid item xs={2} md={2} lg={2}>
                <CancelIcon className="cancel-icon" onClick={props.onClose} />
              </Grid>
            </Grid>
          </div>

          {((props.isOpen &&
            props.isNext &&
            props.selectRadio === "masterData") ||
            props.isUploadScenarioData ||
            props.isUploadBaseLineData ||
            props.showMasterDataModal) &&
          props?.selectedOption !== "CGOMaster" ? (
            /** Upload  master data page*/
            <DialogContent className="modal-body">
              <UploadMasterData
                masterData={props.isNext}
                selectedfile={props.selectedfile}
                getData={props.getData}
                handleChangeFileUpload={props.handleChangeFileUpload}
                handleUploadFile={props.handleUploadFile}
                handleCancelFile={props.handleCancelFile}
                hiddenFileInput={props.hiddenFileInput}
                isUploadMasterFile={props.isUploadMasterFile}
                handleBack={props.handleBack}
                handleUploadNow={handleUploadNowWrapper}
                selectRadio={props.selectRadio}
                handleOpenBaseLineUploader={props.handleOpenBaseLineUploader}
                handleCloseDonePopup={props.handleCloseDonePopup}
                isUploadScenarioData={props.isUploadScenarioData}
                isUploadBaseLineData={props.isUploadBaseLineData}
                selectedScenario={selectedScenario}
                selectedFolderId={props?.selectedFolderId}
                selectedScenarioId={props?.selectedScenarioId}
              />
            </DialogContent>
          ) : props.isCreateScenarioSelected ||
            (props.isNext &&
              props.selectRadio === "inputData" &&
              props?.selectedOption !== "CGOMaster") ? (
            /** Upload  input data page*/
            <InputData
              handleNextInputData={handleNextInputData}
              handleGoBack={props.handleGoBack}
            />
          ) : props?.selectedOption === "CGOMaster" ? (
            <CGOInputModal
              setModalTitleText={setModalTitleText}
              handleNextInputData={handleNextInputData}
              handleGoBack={props.handleGoBack}
              handleClose={props.onClose}
              handleUploadNow={handleUploadNowWrapper}
              selectRadio={props.selectRadio}
              selectedFolderId={props?.selectedFolderId}
              selectedScenarioId={props?.selectedScenarioId}
            />
          ) : (
            /** Uplooad data page*/
            <>
              <DialogContent className="modal-body">
                {uc === "Short Term" || uc === "Medium Term" ? (
                  <div className="sub-title"> Select Category </div>
                ) : (
                  <></>
                )}

                <div
                  className={
                    props.selectRadio === "masterData"
                      ? "master-check-selected"
                      : "master-check"
                  }
                  // onClick={()=>handleClickMaster("masterData")}
                >
                  <Grid container spacing={1}>
                    <Grid item xs={2} md={2} lg={2}>
                      <Radio
                        checked={
                          selectedScenario === "masterData" ||
                          props.selectRadio === "masterData"
                        }
                        onChange={handleRadioSelection}
                        value="masterData"
                        name="radio-buttons"
                        inputProps={{ "aria-label": "masterData" }}
                      />
                    </Grid>
                    <Grid item xs={9} md={9} lg={9}>
                      <label>
                        {props.isSelectedScenarios === true
                          ? "Create Scenario"
                          : "Integrated Processing and Packaging Facility"}
                      </label>
                    </Grid>
                    <Grid item xs={1} md={1} lg={1}>
                      <InfoIcon
                        className="info-Icon"
                        titleAccess={
                          props.isSelectedScenarios === true
                            ? "Define input parameters and constraints to enable the model to find the most optimal solution."
                            : "The case considers manufacturing processes and the subsequent packaging of products within a single facility."
                        }
                      />
                    </Grid>
                  </Grid>
                </div>
                <div
                  className={
                    props.selectRadio === "inputData"
                      ? "input-check-selected"
                      : "input-check"
                  }
                  // onClick={()=>handleClickMaster("inputData")}
                >
                  <Grid container spacing={1}>
                    <Grid item xs={2} md={2} lg={2}>
                      <Radio
                        checked={
                          selectedScenario === "inputData" ||
                          props.selectRadio === "inputData"
                        }
                        onChange={handleRadioSelection}
                        value="inputData"
                        name="radio-buttons"
                        inputProps={{ "aria-label": "A" }}
                      />
                    </Grid>
                    <Grid item xs={9} md={9} lg={9}>
                      <label>
                        {props.isSelectedScenarios === true
                          ? "View Existing Scenario "
                          : "Separate Processing and Packaging Facilities"}
                      </label>
                    </Grid>
                    <Grid item xs={1} md={1} lg={1}>
                      <InfoIcon
                        className="info-Icon"
                        titleAccess={
                          props.isSelectedScenarios === true
                            ? "Access and review results, parameters and metrics of a previously executed optimization run."
                            : "The case considers separation of manufacturing processes and packaging activities into distinct facilities."
                        }
                      />
                    </Grid>
                  </Grid>
                </div>
              </DialogContent>

              <DialogActions>
                <div className="modal-action">
                  <Button
                    variant="outlined"
                    className="cancel"
                    onClick={props.onClose}
                  >
                    Go back
                  </Button>
                  <Button
                    variant="contained"
                    className={
                      props.selectRadio === "" && selectedScenario === ""
                        ? "disabled-proc-btn"
                        : "Next"
                    }
                    onClick={props.doneSelect}
                  >
                    Proceed
                  </Button>
                </div>
              </DialogActions>
            </>
          )}
        </BootstrapDialog>
      </div>
    </>
  );
}

export default UploadModal;
